import { render } from "./About.vue?vue&type=template&id=3aea6e07&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=3aea6e07&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3aea6e07"

export default script